import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholderText: {
    id: 'expense.components.MileageRatePresetSelect.placeholderText',
    defaultMessage: 'Select a mileage rate',
  },
  perMile: {
    id: 'expense.components.MileageRatePresetSelect.perMile',
    defaultMessage: 'per mile',
  },
  perKilometer: {
    id: 'expense.components.MileageRatePresetSelect.perKilometer',
    defaultMessage: 'per kilometer',
  },
})
